import { Field, getIn } from "formik";
import NumberFormat from "react-number-format";
import React from "react";

import { formatMobileNumber } from "../../../utils/formInputUtils";
import InputError from "../InputError";
import Label from "../Label";

const MobileInput = (props) => {
  const { formEl, errors, touched, disabled, inputClasses } = props;

  let errorData = getIn(errors, formEl.name);
  let isTouched = getIn(touched, formEl.name);
  const className = `Input ${errorData && isTouched ? "is-invalid" : ""} ${
    inputClasses ? inputClasses : ""
  }`;

  const handleChange = (values, setFieldValue, setFieldTouched) => {
    const { value, formattedValue } = values;

    setFieldValue(formEl.name, value);
    setFieldTouched(formEl.name);
  };

  return (
    <div className="FormGroup">
      <Label>{formEl.elementConfig.label}</Label>
      <Field
        name={formEl.name}
        render={({ form, field }) => {
          const { value, onBlur, name } = field;
          const { setFieldValue, setFieldTouched } = form; // `FormikBag`

          return (
            <NumberFormat
              name={name}
              onBlur={onBlur}
              value={value}
              onValueChange={(values) => handleChange(values, setFieldValue, setFieldTouched)}
              format={formatMobileNumber}
              className={className}
              placeholder={formEl.elementConfig.placeholder}
              disabled={disabled}
            />
          );
        }}
      />

      {errorData && isTouched ? <InputError>{errorData}</InputError> : null}
    </div>
  );
};

export default MobileInput;
